import { render, staticRenderFns } from "./DocumentHeader.vue?vue&type=template&id=0d7fe40e&scoped=true&"
import script from "./DocumentHeader.vue?vue&type=script&lang=ts&"
export * from "./DocumentHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentHeader.vue?vue&type=style&index=0&id=0d7fe40e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7fe40e",
  null
  
)

export default component.exports